'use client';

import dynamic from 'next/dynamic';

const VennDiagram = dynamic(() => import('./VennDiagramInPost'));

export default VennDiagram;
